module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/6-off-ffdc949840e1c22c78882ae613290fb1.png";